import React, { useEffect } from "react";
import Html from "utils/Html";
import FilterCountry from "components/employees/features/topfilter/filter.country";
import FilterLocation from "components/employees/features/topfilter/filter.location";
import FilterDepartment from "components/employees/features/topfilter/filter.department";
import FilterActive from "components/employees/features/topfilter/filter.active";
import FilterJobClass from "components/employees/features/topfilter/filter.jobclass";
import FilterJobFunction from "components/employees/features/topfilter/filter.jobfunction";
import FilterSearch from "components/employees/features/topfilter/filter.search";
import { useAlluser } from "context/AlluserContext";

export default function TopContent({ userData }) {
  const { filters, filterData } = useAlluser();

  useEffect(() => {}, []);
  useEffect(() => {
    // Select all dropdown menu containers
    const dropdowns = document.querySelectorAll(".alluser-dropdown");

    // Iterate over each dropdown
    dropdowns.forEach((dropdown) => {
      // Select all dropdown menu items within the current dropdown
      const menus = dropdown.querySelectorAll(".menu.transition");

      // Check if any `.menu.transition` element has the 'visible' class
      const hasVisibleClass = Array.from(menus).some((menu) =>
        menu.classList.contains("visible")
      );

      // Add or remove the `menu-scrollable` class based on visibility
      if (hasVisibleClass) {
        // console.log(`Dropdown '${dropdown.id || dropdown.className}' has a visible menu.`);
        dropdown.classList.remove("menu-scrollable");
      } else {
        // console.log(`Dropdown '${dropdown.id || dropdown.className}' has no visible menu.`);
        dropdown.classList.add("menu-scrollable");
      }
    });
  }, [filters]); // Re-run the effect whenever `filters` changes

  if (!("user_sess" in userData)) {
    return <Html.NoAccess />;
  }
  if (filterData.err === 1) {
    return <div>Fetch request error: {filterData.err_msg}</div>;
  } else if (filterData.data === "") {
    return "";
  }
  return (
    <div id="top-content">
      <form
        key={"form-filter" + filters.key_form}
        id="form-filter"
        className="row"
        method="post"
      >
        <div className="col s12">
          <div
            className="row"
            style={{ marginTop: "10px", marginBottom: "0px" }}
          >
            <div className="col s3">
              <FilterCountry data={filterData.countries} />
            </div>
            <div className="col s3">
              <FilterLocation data={filterData.locations} />
            </div>
            <div className="col s3">
              <FilterDepartment data={filterData.departments} />
            </div>
            <div className="col s3">
              <FilterSearch />
            </div>
          </div>
        </div>
        <div className="col s12">
          <div
            className="row"
            style={{ marginTop: "0px", marginBottom: "10px" }}
          >
            <div className="col s3">
              <FilterActive data={filterData.actives} />
            </div>
            <div className="col s3">
              <FilterJobClass data={filterData.jobclasses} />
            </div>
            <div className="col s3">
              <FilterJobFunction data={filterData.jobfunctions} />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
